import Utils from '../../../../viscomjs/utils/utils';

const EventEmitter = require('eventemitter3');

const init = (Decoration, el, bar) => {
    if (Decoration.initiated) return Decoration;

    Decoration.el = el;
    Decoration.bar = bar;
    Decoration.el.classList.add('visible');

    Decoration.initiated = true;

    return Decoration;
};

const destroy = Decoration => {
    if (!Decoration.initiated) return Decoration;

    Decoration.initiated = false;
    Decoration.el.classList.remove('visible');
    Decoration.removeAllListeners();

    return Decoration;
};

const update = (Decoration, progress) => {
    if (!Decoration.initiated) return Decoration;

    Decoration.bar.setAttribute('style', `transform: scaleX(${progress})`);

    return Decoration;
};

//

//
// OBJECT CONSTRUCTOR:
//
const PreloaderDisplay = () => {
    let Decoration = new EventEmitter();

    const initialProps = {
        initiated: false,
        win: window,
        el: null,
        bar: null,
        mc: null
    };

    Decoration = Utils.extend(Decoration, initialProps);

    // INTERFACE METHODS:
    Decoration.init = (el, bar) => init(Decoration, el, bar);
    Decoration.destroy = () => destroy(Decoration);
    Decoration.update = progress => update(Decoration, progress);

    return Decoration;
};

export {PreloaderDisplay};
export default PreloaderDisplay;
